import React, { Component } from 'react'
import Config from '../configs'
import BtnPlus from '../images/btn_plus.svg'
import BtnMinus from '../images/btn_minus.svg'

class QuantitySelection extends Component {
  increaseQuantity = () => {
    const quantity = this.props.quantity + 1
    this.props.onChange(quantity)
  }

  decreaseQuantity = () => {
    const quantity = this.props.quantity - 1
    this.props.onChange(quantity)
  }

  render() {
    const increase_disabled = this.props.quantity >= this.props.max_qty || this.props.increase_disabled
    const decrease_disabled = this.props.quantity === 1 || this.props.decrease_disabled

    return <span className='quantity-selector-container'>
      <button onClick={this.decreaseQuantity} disabled={decrease_disabled}>
        <img src={BtnMinus} alt='-'/>
      </button>
      <span className='quantity'>{ this.props.quantity }</span>
      <button onClick={this.increaseQuantity} disabled={increase_disabled}>
        <img src={BtnPlus} alt='+'/>
      </button>
    </span>
  }
}

export default QuantitySelection



// WEBPACK FOOTER //
// ./src/components/QuantitySelection.js